export type SubscriptionPlan = {
  id: string;
  type: SubscriptionPlanType;
  name: string;
  country: string;
  currency: string;
  amount: number;
};

export const SubscriptionPlanType = {
  Year: "year",
  Month: "month",
} as const;

export type SubscriptionPlanType = (typeof SubscriptionPlanType)[keyof typeof SubscriptionPlanType];
